import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  RESET_CART_STEP,
  SET_CART_STEP,
  TOGGLE_CART,
} from "../../constants/ActionTypes";
import { setErrorMessage } from "../../utils/helpers";
import { getOrCreateCheckout } from "./Checkout";

/**
 * Dispatch this actioin whenever you lunch new API call
 *
 * @returns
 */
export const fetchStart = () => {
  return {
    type: FETCH_START,
  };
};

/**
 * Dispatch this action after successful API call
 *
 * @returns
 */
export const fetchSuccess = () => {
  return {
    type: FETCH_SUCCESS,
  };
};

/**
 * Dispatch this action on any failure of API call
 *
 * @param {*} error
 * @returns
 */
export const fetchError = error => {
  const message = setErrorMessage(error.status, error.message);
  return {
    type: FETCH_ERROR,
    payload: message,
  };
};

/**
 * Open or close Cart
 * @param isCartOpen
 * @returns {{sidebarOpen, type: *}}
 */
export const toggleCart = isCartOpen => {
  console.log("Toggle cart action dispatched", isCartOpen);
  return dispatch => {
    dispatch(getOrCreateCheckout());
    dispatch({
      type: TOGGLE_CART,
      isCartOpen,
    });
  };
};

/**
 * Reset cart step to 1
 * @returns {{type: string}}
 */
export const resetCartStep = () => {
  return {
    type: RESET_CART_STEP,
  };
};

/**
 * Set cart step
 * @param step
 * @returns
 */
export const setCartStep = step => {
  return {
    type: SET_CART_STEP,
    payload: step,
  };
};
